import { combineReducers, createStore } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import {
  sidebarReducer,
  themeReducer,
  assetsReducer,
  contactsReducer,
  accessReducer,
  accessReceivedReducer,
  messagesReducer,
  userReducer,
  paramsReducer,
  filesReducer,
} from './reducers/index';

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  sidebar: sidebarReducer,
  assets: assetsReducer,
  contacts: contactsReducer,
  accesses: accessReducer,
  accesses_received: accessReceivedReducer,
  messages: messagesReducer,
  user: userReducer,
  params: paramsReducer,
  files: filesReducer,
});

const store = createStore(reducer);

export default store;
